import type { Styles } from '@adornis/ass/style.js';
import { ChemistryLitElement } from '@adornis/chemistry/chemistry-lit-element.js';
import { RXController } from '@adornis/chemistry/controllers/RXController.js';
import { WindowSizeController } from '@adornis/chemistry/controllers/window-size-controller.js';
import type { Renderable } from '@adornis/chemistry/renderable.js';
import { html } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { repeat } from 'lit/directives/repeat.js';
import { BehaviorSubject } from 'rxjs';

interface ChancenTaskBarItem {
  rendereable: Renderable;
  _id: string;
}

const taskBarItems = new BehaviorSubject<ChancenTaskBarItem[]>([]);

/**
 * @element chancen-component-fab-task-bar
 */
@customElement('chancen-component-fab-task-bar')
export class ChancenComponentFabTaskBar extends ChemistryLitElement {
  @state() private readonly _size = new WindowSizeController(this);

  @state() private readonly _items = new RXController(this, taskBarItems);

  override styles(): Styles[] {
    return [
      ...super.styles(),
      {
        ':host': {
          position: 'fixed',
          bottom: this._size.mobile ? this.spacing.sm : this.spacing.md,
          right: this._size.mobile ? this.spacing.sm : this.spacing.md,
          zIndex: '999999',
        },
      },
    ];
  }

  public static addItem(item: ChancenTaskBarItem) {
    if (taskBarItems.value.findIndex(i => i._id === item._id) === -1) {
      taskBarItems.next(taskBarItems.value.concat(item));
    }
  }

  public static removeItemWithID(id) {
    const index = taskBarItems.value.findIndex(i => i._id === id);
    if (index !== -1) {
      const values = taskBarItems.value;
      values.splice(index, 1);
      taskBarItems.next(values);
    }
  }

  override render() {
    return html`
      <cr-flex horizontal space=${this._size.mobile ? 'xs' : 'sm'}>
        ${repeat(
          this._items.value ?? [],
          item => item._id,
          item => item.rendereable,
        )}
      </cr-flex>
    `;
  }
}
